import { useTheme } from '@mui/material'
import { useCallback, useEffect, useRef } from 'react'
import AppStore from '@v4/store/appStore'
import { SPACING_FACTOR } from '@v4/constants/pages'
import { useSectionMetaData } from '../../SectionItem.context'

export const useOuterContainer = ({ collection, ...rootProps }) => {
	const {
		typography: { pxToRem },
	} = useTheme()
	const rootRef = useRef(null)
	const setSectionHeight = AppStore.useStoreActions(actions => actions.ui.setSectionHeight)
	const metaData = useSectionMetaData()
	const needCalcHeight = ['fixed', 'absolute'].includes(metaData.position?.metaValue)

	const handleUpdateHeight = useCallback(() => {
		if (rootRef.current) {
			setSectionHeight({
				name: collection,
				value: pxToRem(rootRef.current.offsetHeight).replace('rem', '') / SPACING_FACTOR,
			})

			setTimeout(() => {
				const event = new Event('header-updated')

				window.dispatchEvent(event)
			}, 0)
		}
	}, [pxToRem, collection, setSectionHeight])

	useEffect(() => {
		if (!needCalcHeight) {
			return undefined
		}
		let timeout = null
		const handleResize = () => {
			clearTimeout(timeout)
			handleUpdateHeight()
			timeout = setTimeout(() => {
				handleUpdateHeight()
			}, 100)
		}

		handleResize()

		window.addEventListener('resize', handleResize)

		return () => {
			window.removeEventListener('resize', handleResize)
			clearTimeout(timeout)
			setSectionHeight({ name: collection, value: null })
		}
		// eslint-disable-next-line
	}, [metaData])

	return [{ rootProps, rootRef }, { handleUpdateHeight: needCalcHeight ? handleUpdateHeight : undefined }]
}
